// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"FiltersSkeletons_skeleton__1PAVX","skeleton-anim":"FiltersSkeletons_skeleton-anim__Vandr"};